import {
  Button,
  createStyles,
  FormControl,
  Input,
  InputLabel,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core'
import CloudUpload from '@material-ui/icons/CloudUpload'
import * as React from 'react'


interface IDInfoProps extends WithStyles<typeof styles> {
  onChange: (e: React.FormEvent<HTMLDivElement>) => void,
  onUpload: () => void,
  inputRef: React.RefObject<HTMLFormElement>
  disabled?: boolean
}

const IDInfo: React.FC<IDInfoProps> = (props: IDInfoProps) => {
  const { inputRef, onChange, onUpload, disabled } = props
  const disabledBtn = (disabled === true)
  return (
    <FormControl onChange={onChange} variant="outlined">
      <InputLabel htmlFor="id-doc" style={{ display: 'none' }}>
        {"docSubmitButton.documentFile"}
 								<Input
          id="id-doc"
          aria-describedby="id-doc-upload"
          inputProps={{
            type: 'file',
            accept: 'image/*, .pdf',
            style: { display: 'none' },
            placeholder: "docSubmitButton.documentFile",
          }}
          inputRef={inputRef}
        />
      </InputLabel>

      <Button
        variant="contained"
        color="default"
        onClick={onUpload}
        data-auto="file-upload-button"
        disabled={disabledBtn}
      >
        <CloudUpload style={{ paddingRight: '5px' }} />
          Upload File
 			</Button>
    </FormControl>
  )
}

const styles = (theme: Theme) =>
  createStyles({
    root: {}
  })

export default withStyles(styles)(IDInfo)
